<template>
    <div
        ref="modal"
        class="modal fade"
        :class="{show, 'd-block': activeIframeModalInterval}"
        tabindex="-1"
        role="dialog"
    >
        <div class="modal-dialog m-0 h-100 w-100" role="document" style="max-width: 100%;">
            <div class="modal-content h-100">
                <div class="modal-header">
                    <h5 class="modal-title text-dark">{{ title }}</h5>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="toggleModal()"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-0">
                    <iframe :src="src"
                            :title="title"
                            class="w-100 h-100"
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalIframe",
    props: {
        title: {type: String, required: false, default: 'Kundeguide'},
        src: {type: String, required: false, default: 'https://www.steptransport.dk/kundeguide.html'}
    },
    data() {
        return {
            activeIframeModalInterval: false,
            show: false,
        }
    },
    methods: {
        toggleModal() {
            const body = document.querySelector("body");
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
            this.$parent.toggleActiveIframeModalInterval();
            this.activeIframeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
    }
}

</script>

<style scoped>
</style>
